var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2.167C20 1.25 19.25.5 18.333.5H1.667C.75.5 0 1.25 0 2.167v16.666C0 19.75.75 20.5 1.667 20.5h16.666c.917 0 1.667-.75 1.667-1.667V2.167Z",
    fill: "#2955DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.216 15.376a.714.714 0 0 1-.131-.151l-.002-.059v-.002l.001-.007a.22.22 0 0 1 .018-.066l.028-.014.057-.057 3-3 .354-.354-.354-.353-.667-.667a1.21 1.21 0 0 1 0-1.71c.306-.305.649-.42 1.076-.358l.248.035.176-.176 1.167-1.167.057-.057.037-.073c.076-.154.107-.324.126-.428l.002-.008.004-.021c.018-.103.032-.178.053-.25.054-.118.082-.23.1-.301 0-.004.002-.008.003-.011a.737.737 0 0 1 .045-.148c.043-.086.079-.156.112-.215.031-.054.046-.073.046-.073l-.002.002c.093-.093.159-.104.189-.104s.096.011.188.104L14.73 9.27a.492.492 0 0 1 .094.12c.006.012.008.02.009.023v.003c0 .002 0 .014-.004.031a.261.261 0 0 1-.014.044l-.028.014-.056.057V9.56s-.018.015-.073.046a4.56 4.56 0 0 1-.215.112c-.195.098-.25.114-.276.114h-.081l-.077.026c-.129.042-.24.08-.338.106a.838.838 0 0 1-.17.035h-.208l-.146.146-1.167 1.167-.182.182.042.254c.057.34-.058.761-.36 1.064a1.21 1.21 0 0 1-1.71 0l-.666-.667-.369-.368-.353.383-2.909 3.158a.475.475 0 0 1-.113.088.11.11 0 0 1-.023.009H5.284l-.046-.023a.337.337 0 0 1-.022-.017Z",
    fill: "#fff",
    stroke: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgPin;